import React from "react";
import { MessageSquare } from "lucide-react";

/** NEURAL LINK terminal panel — shows the latest AI/user exchanges as a compact console. */
export const NeuralLink = ({ chatLog, userName }) => {
    const recent = (chatLog || []).slice(-4);
    const name = (userName || "you").toLowerCase();

    return (
        <div
            className="rounded-lg border border-meye-border bg-black/60 px-3 py-2 font-mono text-xs leading-relaxed"
            data-testid="neural-link"
        >
            <div className="flex items-center gap-1.5 text-zinc-500 text-[10px] uppercase tracking-widest mb-1.5">
                <MessageSquare size={11} strokeWidth={1.5} />
                <span>neural link</span>
            </div>
            <div className="space-y-0.5">
                <div className="text-meye-fuchsia">
                    <span className="opacity-80">mEYEtrainer&gt;</span> mEYE AI production link online.
                </div>
                {recent.length === 0 && (
                    <div className="text-zinc-600 italic">
                        <span className="opacity-60">// awaiting command...</span>
                    </div>
                )}
                {recent.map((m, i) =>
                    m.role === "user" ? (
                        <div key={i} className="text-meye-cyan whitespace-pre-wrap break-words" style={{ overflowWrap: "anywhere" }}>
                            <span className="opacity-80">{name}&gt;</span> {m.text}
                        </div>
                    ) : (
                        <div key={i} className="text-meye-fuchsia whitespace-pre-wrap break-words" style={{ overflowWrap: "anywhere" }}>
                            <span className="opacity-80">mEYEtrainer&gt;</span> {m.text || (m.training_question ? "? " + m.training_question : "...")}
                        </div>
                    ),
                )}
            </div>
        </div>
    );
};

export default NeuralLink;
